export interface EmailTemplateProps {}

export enum EmailTemplateType {
  ShareContentPlanner = 'SHARE_CONTENT_PLANNER',
  InviteForAdvocate = 'INVITE_FOR_ADVOCATE',
  AssignNewStory = 'ASSIGN_NEW_STORY',
  InviteToShare = 'INVITE_ADVOCATE_SHARE_STORY',
}

export const EmailTemplateShortCode: Record<string, string[]> = {
  INVITE_FOR_ADVOCATE: ['advocateName', 'companyName', 'ebName'],
  SEND_A_NUDGE: ['advocateName', 'headline', 'questions', 'ebName'],
  ASSIGN_NEW_STORY: ['advocateName', 'headline', 'questions', 'ebName'],
  SHARE_CONTENT_PLANNER: ['name', 'ebName'],
  INVITE_ADVOCATE_SHARE_STORY: ['advocateName', 'companyName', 'ebName'],
};

export const EmailTemplateTypeTextKeys: Record<string, string> = {
  INVITE_FOR_ADVOCATE: 'Settings.MessageTemplates.InviteEmployees',
  ASSIGN_NEW_STORY: 'Settings.MessageTemplates.AssignStories',
  SHARE_CONTENT_PLANNER: 'Settings.MessageTemplates.ShareContentPlanner',
  INVITE_ADVOCATE_SHARE_STORY: 'Settings.MessageTemplates.ShareSocialPosts',
};

export const getEmailTemplateTypeText = (
  t: (key: string) => string,
): Record<string, string> =>
  Object.entries(EmailTemplateTypeTextKeys).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: t(value),
    }),
    {} as Record<string, string>,
  );
